module.exports = __webpack_public_path__ + "static/media/OPTIWEIGH-LOGO.47edb131.svg";